import { alpha } from '@mui/material';

export const MuiBackdropConfig = {
    styleOverrides: {
        root: ({ theme }: { ownerState: any; theme: any }) => {
            return {
                zIndex: theme.zIndex.drawer + 1,
                backgroundColor: alpha(theme.palette.text.primary, 0.3),
                color: theme.palette.background.default,
                '&.loading-placeholder--view-secondary': {
                    backgroundColor: alpha(theme.palette.background.default, 0.5),
                    color: alpha(theme.palette.text.primary, 0.4),
                },
            };
        },
    },
};
